
import "./ModalitaPagamento.css";
import IModalitaPagamentoProps from "pages/Prenotazione/Form/ModalitaPagamento/IModalitaPagamentoProps";
import Riepilogo from "components/Riepilogo/Riepilogo";
import SceltaModalitaPagamento from "components/SceltaModalitapagamento/SceltaModalitapagamento";
import { Enhanced } from "utils/ReactUtils";

const ModalitaPagamento: React.FC<IModalitaPagamentoProps> = ({ OnSubmit, Back, t, dataForm }) => {
	return (
		<div id="modalita-pagamento">
			<div className="title">
				<span>{t("modalitaPagamento.title")}</span>
			</div>
			<Riepilogo />

			<SceltaModalitaPagamento
				OnSubmit={OnSubmit}
				Back={Back}
				NuovaPrenotazione={true}
				BackButtonVisible={true}
				NoteFieldVisible={true}
			></SceltaModalitaPagamento>
		</div>
	);
};

export default Enhanced( ModalitaPagamento,{componentNamespace:"ModalitaPagamento"});
